module.exports = __webpack_public_path__ + "img/background-panel-hello-max.4e367a50.svg";